/* eslint-disable  */
import React from 'react';
import { ArrayField, FunctionField, TextField, useListContext, usePermissions, useTranslate } from 'react-admin';
import WealthShowGuesser from '../../base/components/guesser/wealth-show.guesser';
import { transformIdValue } from '../../services/util/stringUtil';
import { ID_EMPTY, MONTH_DISPLAY_FORMAT } from '../../constant';
import resourceSlug from '../../constant/resource-slug';
import ArrayWithPaginationField from '../../base/components/ra/fields/arrayWithPagination.field';
import CustomLinkField from '../../base/components/ra/fields/customLink.field';
import { Box } from '@material-ui/core';
import FeaturesTable from '../brand/components/FeaturesTable';
import { useAuthUser } from '../../base/hooks';
import { INVOICE_SERVICE } from '../../constant/invoice';
import { useHasReadInvoicePermission } from './components/utils';
import AmountField from '../../base/components/ra/fields/amount.field';
import Labeled from '../../base/components/ra/labeled';
import { DateField } from '../../base/components/ra/fields';

const GroupShow = (props) => {
  const { permissions } = usePermissions();
  const hasReadInvoicePermission = useHasReadInvoicePermission();
  const user = useAuthUser();
  const translate = useTranslate();

  const hasFeaturesReadPermission =
    user?.superman ||
    (Array.isArray(permissions) && !!permissions?.find((item) => item.resource.name === resourceSlug.FEATURES)?.read);
  return (
    <WealthShowGuesser
      excludeFields={['brands', 'currencies', 'features']}
      extraSections={
        hasReadInvoicePermission && [
          <Box title={translate('resources.group.invoiceSettings')}>
            <FunctionField
              label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MONTHLY_GGR}`}
              render={(record) => {
                const monthlyRoyalty = record.royalty?.find?.(
                  (item) => item.invoiceService === INVOICE_SERVICE.MONTHLY_GGR,
                )?.value;

                if (monthlyRoyalty) return `${monthlyRoyalty}%`;

                return '-';
              }}
            />
            <FunctionField
              label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MKT_FREE_SPIN}`}
              render={(record) => {
                const mktRoyaltyRate = record.royalty?.find?.(
                  (item) => item.invoiceService === INVOICE_SERVICE.MKT_FREE_SPIN,
                )?.value;

                if (mktRoyaltyRate) return `${mktRoyaltyRate}%`;

                return '-';
              }}
            />
            <TextField source="invoiceProfile.paymentTermDays" label={'resources.group.fields.paymentTerms'} />
            <TextField source="invoiceProfile.companyName" label={'resources.group.fields.companyName'} />
            <TextField source="invoiceProfile.country" label={'resources.group.fields.country'} />
            <TextField source="invoiceProfile.city" label={'resources.group.fields.city'} />
            <TextField source="invoiceProfile.regNo" label={'resources.group.fields.regNo'} />
            <Labeled label="resources.group.fields.openingBalance">
              <AmountField source="openingBalance" symbol="USD" />
            </Labeled>
            <Labeled label="resources.group.fields.openingBalanceTime">
              <DateField source="openingBalanceTime" dateFormat={MONTH_DISPLAY_FORMAT} />
            </Labeled>
            <FunctionField
              className="fieldInOneLine"
              label={'resources.group.fields.companyAddress'}
              render={(record) => getAddressLines(record.invoiceProfile || {}).join(', ')}
            />
          </Box>,
        ]
      }
      extraAnotherBlocks={[
        hasFeaturesReadPermission && (
          <FeaturesTable title={translate('resources.feature-flag.name')} source="features" />
        ),
        <ArrayWithPaginationField source="brands" label={false}>
          <CustomLinkField
            sortable={false}
            source="id"
            href={(record) => `/#/${resourceSlug.BRAND}/${record.id}/show`}
            title={(record) => (record.id ? transformIdValue(record.id) : ID_EMPTY)}
          />
          <TextField source="name" sortable={false} label={'resources.group.fields.name'} />
          <TextField source="code" sortable={false} />
          <ArrayField source="features" label={'resources.feature-flag.name'}>
            <BrandFeatureFlags />
          </ArrayField>
        </ArrayWithPaginationField>,
        <ArrayWithPaginationField source="currencies" label={false}>
          <CustomLinkField
            sortable={false}
            source="id"
            href={(record) => `/#/${resourceSlug.CURRENCY}/${record.id}/show`}
            title={(record) => (record.id ? transformIdValue(record.id) : ID_EMPTY)}
          />
          <TextField source="name" sortable={false} label={'resources.group.fields.name'} />
          <TextField source="code" sortable={false} />
        </ArrayWithPaginationField>,
      ]}
      {...props}
    />
  );
};

const BrandFeatureFlags = () => {
  const { data } = useListContext();
  const features = Object.values(data || {});
  return (
    <div>
      {features?.map((feature) => (
        <Box
          width="fit-content"
          display="flex"
          alignItems="center"
          sx={{
            gap: 4,
            '&:before': {
              content: '""',
              display: 'block',
              width: 5,
              height: 5,
              borderRadius: 1000,
              background: 'black',
            },
          }}
          key={feature.id}
        >
          {feature.name}
        </Box>
      ))}
    </div>
  );

  return null;
};

export const getAddressLines = (obj) => {
  return Object.entries(obj)
    .filter(([key, value]) => key.startsWith('addressLine') && value)
    .map(([_, value]) => value.trim());
};

export default GroupShow;
